<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <!-- 数据筛选 -->
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="100px">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="queryParams.roleName" placeholder="请输入角色名称"  clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="角色标签" prop="roleLabel">
        <el-input v-model="queryParams.roleLabel" placeholder="请输入角色标签" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="是否禁用" prop="isDisable">
        <el-select v-model="queryParams.isDisable" placeholder="请选择是否禁用" clearable @change="handleQuery">
          <el-option :value="1" label="是">是</el-option>
          <el-option :value="0" label="否">否</el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格操作 -->
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['system:role:add']" type="primary" plain size="mini" icon="el-icon-plus" @click="openModel(null)">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['system:role:remove']" type="danger" plain size="mini" icon="el-icon-delete" :disabled="multiple" @click="handleDelete">批量删除</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>
    <!-- 表格展示 -->
    <el-table border :data="roleList" @selection-change="selectionChange" v-loading="loading" >
      <!-- 表格列 -->
      <el-table-column type="selection" width="55" />
      <el-table-column prop="roleName" label="角色名称" align="center" />
      <el-table-column prop="roleLabel" label="角色标签" align="center">
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.roleLabel }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="isDisable" label="禁用状态" align="center" width="100">
        <template slot-scope="scope">
          <el-switch
            v-if="$auth.hasPermiOr(['system:role:add','system:role:edit'])"
            v-model="scope.row.isDisable"
            active-color="#13ce66"
            inactive-color="#F4F4F5"
            :active-value="1"
            :inactive-value="0"
            @change="changeDisable(scope.row)"
          />
          <el-tag v-else :type="scope.row.isDisable === 0 ? 'success': 'danger'" >{{scope.row.isDisable === 0 ? '正常': '禁用'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.createTime | dateTime }} </span>
        </template>
      </el-table-column>
      <!-- 列操作 -->
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button v-hasPermi="['system:role:edit']" type="text" size="mini" icon="el-icon-edit" @click="openModel(scope.row)">修改</el-button>
          <el-button v-hasPermi="['system:role:remove']" type="text" size="mini" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
    <!-- 菜单对话框 -->
    <el-dialog :title="roleTitle" :visible.sync="open" width="400px" :close-on-click-modal="false" >
      <el-form ref="roleForm" label-width="90px" :model="roleForm" :rules="roleRules">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="roleForm.roleName"  />
        </el-form-item>
        <el-form-item label="权限标签" prop="roleLabel">
          <el-input v-model="roleForm.roleLabel"  />
        </el-form-item>
        <el-form-item label="菜单权限" prop="menuIdList">
          <el-tree
            :data="menuList"
            :default-checked-keys="roleForm.menuIdList"
            show-checkbox
            node-key="id"
            ref="menuTree"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submitForm">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRoleList,
  addRoles,
  updateRoles,
  removeRoles,
  updateRolesDisable,
  getRoleMenusList,
  getRoleInfo
} from "@/api/system/role";
export default {
  created() {
    this.getList();
  },
  data: function() {
    return {
      loading: true,
      showSearch:true,
      roleList: [],
      // 非多个禁用
      multiple: true,
      roleIds: [],
      roleNameList: [],
      total: 0,
      roleTitle: "",
      open: false,
      roleForm: {
        roleName: "",
        roleLabel: "",
        menuIdList: []
      },
      roleRules:{
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" }
        ],
        roleLabel: [
            { required: true, message: "请输入权限标签", trigger: "blur" }
        ]
      },
      menuList: [],
      queryParams: {
        current: 1,
        size: 10,
        roleLabel: null,
        roleName: null,
        isDisable: null
      }
    };
  },
  methods: {
    handleQuery(){
      this.queryParams.current = 1;
      this.getList();
    },
    resetQuery(){
      this.resetForm("queryForm");
      this.handleQuery()
    },
    selectionChange(selection) {
      this.roleIds = selection.map(item => item.roleId);
      this.roleNameList = selection.map(item => item.roleName);
      this.multiple = !selection.length;
    },
    getList() {
      getRoleList(this.queryParams).then(res => {
        this.roleList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    },
    handleDelete(row) {
      let ids = this.roleIds;
      let names = this.roleNameList;
      if (row.roleId) {
        ids = [row.roleId];
        names = [row.roleName];
      }
      this.$modal.confirm('是否确认删除角色为"' + names + '"的数据项？').then(function() {
          return removeRoles(ids);
        }).then(() => {
          this.getList();
        }).catch(() => {});
    },
    changeDisable(role) {
      let oper = role.isDisable === 0 ? "启用" : "禁用";
      let data = {
        id: role.roleId,
        yesOrNot: role.isDisable
      };
      updateRolesDisable(data).then(res => {
        if (res.flag) {
          this.$modal.msgSuccess(oper + "成功");
          this.getList();
        }
      });
    },

    reset(){
      this.roleForm = {
        roleId:  null,
        roleName: "",
        roleLabel: "",
        menuIdList: []
      };
      this.$nextTick(() => {
        this.$refs.menuTree.setCheckedKeys([]);
      });
      this.resetForm('roleForm')
    },
    cancel(){
      this.open = false;
      this.reset()
    },
    openModel(role) {
      this.reset();
      this.roleTitle = role ? "修改角色" : "新增角色";
      getRoleMenusList().then(res => {
        this.menuList = res.data;
        if (role != null) {
          getRoleInfo(role.roleId).then(res => {
            this.roleForm = res.data;
          });
        }
      });
      this.open = true;
    },
    submitForm() {
      this.$refs.roleForm.validate(valid => {
        if (valid) {
          this.roleForm.menuIdList = this.$refs.menuTree.getCheckedKeys().concat(this.$refs.menuTree.getHalfCheckedKeys());
          if(this.roleForm.roleId != null){
            updateRoles(this.roleForm).then(res => {
              if (res.flag) {
                this.getList();
                this.$modal.msgSuccess("修改成功");
              } else {
                this.$modal.msgError("修改失败");
              }
              this.open = false;
            });
          }else {
            addRoles(this.roleForm).then(res => {
              if (res.flag) {
                this.getList();
                this.$modal.msgSuccess("新增成功");
              } else {
                this.$modal.msgError("新增失败");
              }
              this.open = false;
            });
          }
        }
      })
    }
  }
};
</script>
